import React, { Fragment } from "react";
import FieldListFactory from "components/FieldListFactory";
import {
  DATEPICKER_FORMAT_TYPE_OPTIONS,
  DATEPICKER_TIMEFRAME_OPTIONS
} from "utils/constants/datepicker";
import { getFieldPath } from "utils/form";
import MultiselectOption from "components/MultiselectOption";
import MultiSelect from "components/Form/fields/MultiSelect";
import { useFormikContext } from "formik";
import get from "lodash/get";
import { STATE_KEYS } from "utils/constants/state";
import Toggle from "react-toggle";
import { getToggleProps } from "utils/form";

const COMMON_SELECT_PROPS = {
  isMulti: false,
  labelTransform: (value) => value,
  components: {
    Option: MultiselectOption
  }
};

const ValuesFields = ({ name }) => {
  const {
    values,
    touched,
    setFieldValue,
    setFieldTouched
  } = useFormikContext();

  const formatPath = getFieldPath(
    name,
    STATE_KEYS.DATEPICKER.PRESENTATION_FORMAT
  );
  const formatValue = get(values, formatPath);
  const formatTouched = get(touched, formatPath);
  const selectedFormat = DATEPICKER_FORMAT_TYPE_OPTIONS.find(
    (option) => option.uid === formatValue
  );

  const timeframePath = getFieldPath(
    name,
    STATE_KEYS.DATEPICKER.PRESENTATION_TIMEFRAME_TYPE
  );

  const timeframeValue = get(values, timeframePath);
  const timeframeTouched = get(touched, timeframePath);
  const selectedTimeframe = DATEPICKER_TIMEFRAME_OPTIONS.find(
    (option) => option.uid === timeframeValue
  );

  let formatSelections = [];
  if (selectedFormat) {
    formatSelections = [
      {
        id: selectedFormat.uid,
        name: selectedFormat.label
      }
    ];
  }
  const selectFormatProps = {
    ...COMMON_SELECT_PROPS,
    value: formatSelections,
    placeholder: "Select date format",
    options: DATEPICKER_FORMAT_TYPE_OPTIONS,
    onChange: () => ({ value }) => {
      setFieldValue(formatPath, value);

      if (!formatTouched) {
        setFieldTouched(formatPath, true);
      }
    }
  };
  let timeframeSelections = [];
  if (selectedTimeframe) {
    timeframeSelections = [
      {
        id: selectedTimeframe.uid,
        name: selectedTimeframe.label
      }
    ];
  }
  const selectTimeframeProps = {
    ...COMMON_SELECT_PROPS,
    value: timeframeSelections,
    placeholder: "Select date timeframe",
    options: DATEPICKER_TIMEFRAME_OPTIONS,
    onChange: () => ({ uid }) => {
      setFieldValue(timeframePath, uid);

      if (!timeframeTouched) {
        setFieldTouched(timeframePath, true);
      }
    }
  };

  const controlsTimePath = getFieldPath(
    name,
    STATE_KEYS.DATEPICKER.PRESENTATION_CONTROLS_TIME
  );
  const timeActive = Boolean(get(values, controlsTimePath));

  return (
    <Fragment>
      <FieldListFactory
        name={name}
        config={[
          {
            name: "label"
          },
          {
            name: "description"
          }
        ]}
      />
      <div className="pt3">
        <label className="f6 mb2 dib fw6">Format</label>
        <MultiSelect {...selectFormatProps} />
      </div>
      <div className="pt3">
        <label className="f6 mb2 dib fw6">Timeframe</label>
        <MultiSelect {...selectTimeframeProps} />
      </div>
      <div className="pt3 w-100">
        <div className="flex flex-row w-100 justify-between items-center pb2">
          <div className="f6 dib fw6">Time</div>
          <Toggle
            {...getToggleProps({
              active: timeActive,
              setFieldValue: (_, active) => {
                setFieldValue(controlsTimePath, active);
                setFieldTouched(controlsTimePath, true);
              }
            })}
          />
        </div>
        <div className="f6 lh-copy">Show time controls within datepicker.</div>
      </div>
    </Fragment>
  );
};

export default ValuesFields;
